import { Link } from "react-router-dom";

import HeaderMain from "../comp/head-navs-main";
import ViewContent from "../comp/view-content";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import UserInfoCard from "../comp/user-infocard";

export default function Settings() {

  return (
    <>
      <HeaderMain />
      <ViewContent 
        content={
          <>
            <ViewDividerSmall />
            <UserInfoCard />

            <ViewDividerMedium />
            <Link to={"/sessionx"} className="text-primary">Logout</Link>


            <ViewDividerMedium />
            <ViewDividerMedium />
          </>
        }
      />
    </>
  )
}